// extracted by mini-css-extract-plugin
module.exports = {"gameEndModal":"GameEndModal_gameEndModal__2iVR3","confetti":"GameEndModal_confetti__2V4YC"};